import { Input, Select } from 'antd';
const { Option } = Select;
import PopoverHeader from '../../../../../../../../common/PopoverHeader';

const FLOAT_REGEX = /^[+-]?\d*(\.\d*)?$/;

const DropRateSelectAfter = ({
    onChange,
    value,
}: {
    onChange: (value: string) => void;
    value: string;
}) => {
    return (
        <Select defaultValue="drops/min" onChange={onChange} value={value}>
            <Option value="drops/hr">drops/hr</Option>
            <Option value="drops/min">drops/min</Option>
        </Select>
    );
};

const FLowRateSelectAfter = ({
    onChange,
    value,
}: {
    onChange: (value: string) => void;
    value: string;
}) => {
    return (
        <Select defaultValue="ml/min" onChange={onChange} value={value}>
            <Option value="ml/min">ml/min</Option>
            <Option value="ml/hr">ml/hr</Option>
        </Select>
    );
};

const OverTimeSelectAfter = ({
    onChange,
    value,
}: {
    onChange: (value: string) => void;
    value: string;
}) => {
    return (
        <Select defaultValue="min" onChange={onChange} value={value}>
            <Option value="min">min</Option>
            <Option value="hr">hr</Option>
        </Select>
    );
};

const InfusionRatePopup = ({
    onClose,
    dropFlowRate,
    flowRate,
    flowTime,
    onChange,
}: {
    onClose: () => void;
    dropFlowRate: string;
    flowRate: string;
    flowTime: string;
    onChange: ({
        value,
        type,
    }: {
        value: string;
        type: 'iv-drop-rate' | 'iv-rate' | 'flow-time';
    }) => void;
}): JSX.Element => {
    return (
        <>
            <PopoverHeader title={'Add infusion rate details'} onClose={onClose} />
            <div className="py-12 px-16">
                <div className="flex flex-col space-y-16">
                    <div className="flex flex-col space-y-8">
                        <div className="text-13 font-700">IV flow rate (in drops):</div>
                        <Input
                            addonAfter={
                                <DropRateSelectAfter
                                    value={dropFlowRate.split(' ')[1] || 'drops/min'}
                                    onChange={(value) => {
                                        onChange({
                                            value: `${dropFlowRate.split(' ')[0]} ${
                                                value ?? 'drops/min'
                                            }`,
                                            type: 'iv-drop-rate',
                                        });
                                    }}
                                />
                            }
                            value={dropFlowRate.split(' ')[0]}
                            onChange={(e) => {
                                if (!FLOAT_REGEX.test(e.target.value)) {
                                    return;
                                }
                                onChange({
                                    value: `${e.target.value} ${
                                        dropFlowRate.split(' ')[1] ?? 'drops/min'
                                    }`,
                                    type: 'iv-drop-rate',
                                });
                            }}
                            className="w-124"
                            placeholder="10"
                        />
                    </div>
                    <div className="flex flex-col space-y-8">
                        <div className="text-13 font-700">IV flow rate:</div>
                        <Input
                            addonAfter={
                                <FLowRateSelectAfter
                                    value={flowRate.split(' ')[1] || 'ml/min'}
                                    onChange={(value) => {
                                        onChange({
                                            value: `${flowRate.split(' ')[0]} ${value ?? 'ml/min'}`,
                                            type: 'iv-rate',
                                        });
                                    }}
                                />
                            }
                            onChange={(e) => {
                                if (!FLOAT_REGEX.test(e.target.value)) {
                                    return;
                                }
                                onChange({
                                    value: `${e.target.value} ${
                                        flowRate.split(' ')[1] ?? 'ml/min'
                                    }`,
                                    type: 'iv-rate',
                                });
                            }}
                            value={flowRate.split(' ')[0]}
                            className="w-124"
                            placeholder="10"
                        />
                    </div>
                    <div className="flex flex-col space-y-8">
                        <div className="text-13 font-700">Duration:</div>
                        <Input
                            addonBefore={'Over'}
                            addonAfter={
                                <OverTimeSelectAfter
                                    value={flowTime.split(' ')[1] || 'min'}
                                    onChange={(value) => {
                                        onChange({
                                            value: `${flowTime.split(' ')[0]} ${value ?? 'min'}`,
                                            type: 'flow-time',
                                        });
                                    }}
                                />
                            }
                            onChange={(e) => {
                                if (isNaN(Number(e.target.value))) {
                                    return;
                                }
                                onChange({
                                    value: `${e.target.value} ${flowTime.split(' ')[1] ?? 'min'}`,
                                    type: 'flow-time',
                                });
                            }}
                            value={flowTime.split(' ')[0]}
                            className="w-124"
                            placeholder="10"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default InfusionRatePopup;
